export default __webpack_public_path__ + "396b4cacb8f05a0b3cfa036796482a02.png";